import React from "react";
import { Link } from "react-router-dom";

import SettlementStatusBadge from "./SettlementStatusBadge";

const SettlementTable = ({ settlements }) => {

    return (

        <div className="settlement-table">

            <table>

                <thead>

                    <tr>

                        <th>Provider</th>

                        <th>Orders</th>

                        <th>Revenue</th>

                        <th>Commission</th>

                        <th>Payable</th>

                        <th>Status</th>

                        <th>Action</th>

                    </tr>

                </thead>

                <tbody>

                    {settlements.map((item) => (

                        <tr key={item._id}>

                            <td>
                                {item.provider?.businessName}
                            </td>

                            <td>
                                {item.totalOrders}
                            </td>

                            <td>
                                ₹{item.totalRevenue}
                            </td>

                            <td>
                                ₹{item.commission}
                            </td>

                            <td>
                                ₹{item.payableAmount}
                            </td>

                            <td>

                                <SettlementStatusBadge
                                    status={item.settlementStatus}
                                />

                            </td>

                            <td>

                                <Link
                                    to={`/admin/settlements/${item._id}`}
                                >
                                    View
                                </Link>

                            </td>

                        </tr>

                    ))}

                </tbody>

            </table>

        </div>

    );

};

export default SettlementTable;